<div class="modal-body modal-scss">
  <div [formGroup]="form" class="mb-3">
    <div class="row">
      <div class="col-12">
        <label class="w-100">
          <span class="super-compos-label-input">{{ 'modals.documentTitle' | translate }}</span>
          <i-input
            [type]="'text'"
            [iInput]="{ placeholder: 'Titre du document' }"
            [control]="form.get('description')"
            [showError]="false"
            styleClass="d-block w-100"></i-input>
        </label>
        @if (f.description.invalid && f.description.errors['required']) {
          <div class="input-error">{{ 'modals.titleIsRequired' | translate }}</div>
        }
        @if (f.description.dirty && f.description.invalid && f.description.errors['maxlength']) {
          <div class="input-error">
            {{ 'modals.titleCannotExceed' | translate }}
          </div>
        }
        @if (!form.valid) {
          <div class="input-error">{{ 'modals.unauthorizedCharacters' | translate }}</div>
        }
      </div>

      @if (showDateLimite) {
        <div class="col-12 mt-3">
          <label class="w-100">
            <span class="super-compos-label-input">{{ 'modals.deadline' | translate }}</span>
            <i-input [type]="'calendar'" [iInput]="{ options: { dateFormat: 'dd/mm/yy' } }" [control]="form.get('dateLimite')"> </i-input>
          </label>
        </div>
      }
    </div>
  </div>
  <i-button
    [text]="'back' | translate"
    styleClass="bottomButton red mb-3"
    [pTooltip]="'back' | translate"
    tooltipZIndex="99999999"
    tooltipPosition="bottom"
    (click)="ref.close()"></i-button>
  <i-button
    [disabled]="!form.valid"
    [text]="'save' | translate"
    styleClass="bottomButton green"
    tooltipPosition="bottom"
    tooltipZIndex="99999999"
    (click)="onSubmit()"></i-button>
</div>
